import { orderBy } from 'lodash';
import { translate } from '../Services/translation';

export const OPTICIAN_SET_STORES = 'OPTICIAN_SET_STORES';
export const OPTICIAN_SET_FILTERED_STORES = 'OPTICIAN_SET_FILTERED_STORES';
export const OPTICIAN_SET_PAGE_COUNT = 'OPTICIAN_SET_PAGE_COUNT';
export const OPTICIAN_SET_CURRENT_PAGE = 'OPTICIAN_SET_CURRENT_PAGE';
export const OPTICIAN_SET_CURRENT_CATEGORY = 'OPTICIAN_SET_CURRENT_CATEGORY';
export const OPTICIAN_SET_DISPLAYED_STORES = 'OPTICIAN_SET_DISPLAYED_STORES';
export const OPTICIAN_SET_NAME_FIELTER = 'OPTICIAN_SET_NAME_FIELTER';
export const OPTICIAN_SET_ORDER = 'OPTICIAN_SET_ORDER';
export const OPTICIAN_USER_GEOLOCATION = 'OPTICIAN_USER_GEOLOCATION';

const ITEMS_COUNT_ON_PAGE = 9;
export const ALL_OPTICIAN = translate("coptikk.findstores.all");

const getStoresFromCurrentPage = (currentStores, currentPageNumber) => currentStores && currentStores
    .map((store, index) => ({ ...store, index }))
    .filter(({ index }) => (index >= (currentPageNumber - 1) * ITEMS_COUNT_ON_PAGE) && (index < currentPageNumber * ITEMS_COUNT_ON_PAGE))
    .map((store) => ({ ...store, index: undefined }));

export const setCoords = (coords) => ({
    type: OPTICIAN_USER_GEOLOCATION,
    payload: { coords }
})

const deg2rad = (deg) => deg * (Math.PI / 180);

const orderStores = async (stores, order, coords) => {
    switch (order) {
        case 'NAME_ASC':
            return orderBy(stores, ['storeName'], ['asc']);
        case 'NAME_DESC':
            return orderBy(stores, ['storeName'], ['desc']);
        case 'DIST':
            const { lat, lng } = coords;
            const filteredStores = stores.map(({ storeCoordLat, storeCoordLong, ...other }) => ({ storeCoordLat, storeCoordLong, ...other, distance: getDistanceFromLatLonInKm(storeCoordLat, storeCoordLong, lat, lng) }));
            return filteredStores.sort((a, b) => a.distance - b.distance);
        default:
            return stores
    }
}
const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}

const getCurrentLocation = () => new Promise((resolve, reject) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            ({ coords }) => resolve({
                lat: coords.latitude,
                lng: coords.longitude
            })
        )
    }
});

export const init = (stores) => (dispatch, getState) => {
    const count = Math.ceil((!!stores ? stores.length : 0) / ITEMS_COUNT_ON_PAGE);
    dispatch(setStores(stores));
    dispatch(setPageCount(count));
    dispatch(setCurrentPage(1));
    setDisplayStores(dispatch, getState(), 1);

}

const setDisplayStores = async (dispatch, state, currentPageNumber, _filter = null, filterString, order = 'NAME_ASC') => {
    const stores = state.opticians.currentStores;
    const coords = state.opticians.coords;

    const filter = _filter === ALL_OPTICIAN ? null : _filter;
    const currentStores = filterString ? stores.filter(({ id, storeId, additionalStoreData, storeCoordLong, storeCoordLat, storeCategories, competences, ...strings }) => Object.values(strings).join(' ').toLowerCase().includes(filterString.toLowerCase())) : stores;
    const filteredStores = filter ? currentStores.filter(({ competences }) => competences && competences.includes(filter)) : currentStores;
    const count = Math.ceil((!!filteredStores ? filteredStores.length : 0) / ITEMS_COUNT_ON_PAGE);
    const displayedStores = getStoresFromCurrentPage(await orderStores(filteredStores, order, coords), currentPageNumber);
    dispatch(setPageCount(count));
    dispatch({
        type: OPTICIAN_SET_DISPLAYED_STORES,
        payload: { displayedStores }
    })

}

export const setStores = (currentStores) => ({
    type: OPTICIAN_SET_STORES,
    payload: { currentStores }
})

export const setPageCount = (pageCount) => ({
    type: OPTICIAN_SET_PAGE_COUNT,
    payload: { pageCount }
})

export const setCurrentCategory = (currentCategory) => (dispatch, getState) => {
    dispatch({
        type: OPTICIAN_SET_CURRENT_CATEGORY,
        payload: { currentCategory }
    });
    dispatch(setCurrentPage(1));
    (setDisplayStores(dispatch, getState(), 1, currentCategory, getState().opticians.searchString, getState().opticians.order));
}

export const setOrder = (order) => (dispatch, getState) => {
    if (order == 'DIST') {
        getCurrentLocation().then((coords) => {
            dispatch(setCoords(coords));
            dispatch({
                type: OPTICIAN_SET_ORDER,
                payload: { order }
            });
            dispatch(setCurrentPage(1));
            (setDisplayStores(dispatch, getState(), 1, getState().opticians.currentCategory, getState().opticians.searchString, order));
        });
    } else {
        dispatch({
            type: OPTICIAN_SET_ORDER,
            payload: { order }
        });
        dispatch(setCurrentPage(1));
        (setDisplayStores(dispatch, getState(), 1, getState().opticians.currentCategory, getState().opticians.searchString, order));
    }
}


export const setCurrentPage = (currentPage) => (dispatch, getState) => {
    dispatch({ type: OPTICIAN_SET_CURRENT_PAGE, payload: { currentPage } });
    (setDisplayStores(dispatch, getState(), currentPage, getState().opticians.currentCategory, getState().opticians.searchString, getState().opticians.order));
}

export const incCurrentPage = (inc) => (dispatch, getState) => {
    const { currentPage } = getState().opticians;
    dispatch({ type: OPTICIAN_SET_CURRENT_PAGE, payload: { currentPage } });
    (setDisplayStores(dispatch, getState(), currentPage + inc, getState().opticians.currentCategory, getState().opticians.searchString, getState().opticians.order));
}


export const setSearchString = (searchString) => (dispatch, getState) => {
    dispatch({ type: OPTICIAN_SET_NAME_FIELTER, payload: { searchString } });
    (setDisplayStores(dispatch, getState(), getState().opticians.currentPage, getState().opticians.currentCategory, searchString, getState().opticians.order));
}